<div class="row">
    <div class="col-12 ml-auto mr-auto">
        <div class="dash-card">
            <!-- <app-back-button [defaultRoute]="getBackLink()"
                [useDefaultRoute]="true" [step]="9"></app-back-button> -->

            <ng-container *ngIf="loading">
                <div class="dash-card-body">
                    <div class="row">
                        <div class="col-12 mt-4">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader
                                [theme]="{width: '165px',height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader [theme]="{height: '500px'}">
                            </ngx-skeleton-loader>
                        </div>

                    </div>

                    <div class="row">
                        <div
                            class="col-12 text-right d-flex align-items-center justify-content-end">
                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px',marginRight: '16px'}">
                            </ngx-skeleton-loader>

                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px'}">
                            </ngx-skeleton-loader>

                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading">
                <div class="dash-card-header" *ngIf="!id">
                    <h2><span>Novo tipo de documento</span></h2>
                </div>

                <div class="dash-card-header" *ngIf="id">
                    <h2>Editar tipo de documento <span>{{title}}</span></h2>
                </div>

                <div class="dash-card-body">
                    <form [formGroup]="form" *ngIf="showForm">
                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <app-input [group]="form"
                                    controlName="type_document"
                                    label="Nome do modelo de minuta"
                                    placeholder="Digite">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-lg-2">
                                <p class="input-label">Tipo de usuário</p>
                                <app-radio formControlName="system"
                                    value="data_engine"
                                    [alternativeStyle]="true"
                                    [isChecked]="verifyChecked('system', 'data_engine')">
                                    Cadastro
                                </app-radio>
                                <app-radio formControlName="system"
                                    value="fs_engine" [alternativeStyle]="true"
                                    [isChecked]="verifyChecked('system', 'fs_engine')">
                                    Smart FIDC
                                </app-radio>
                                <app-spacer [bottom]="8"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select [items]="eventOptions"
                                    [group]="form" controlName="event"
                                    label="Evento" placeholder="Selecione">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12">
                                <app-input type="textarea" [group]="form"
                                    controlName="description" [rows]="4"
                                    label="Descrição" [noResize]="true">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </form>

                    <div class="row" *ngIf="!showForm">
                        <div class="col-6 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                Usuário atual
                            </span>

                            <span class="dash-details-card-item-title">
                                {{renderUserName()}}
                            </span>
                        </div>

                        <div class="col-6 d-flex flex-column align-items-end">
                            <span class="dash-details-card-item-subtitle">
                                Data
                            </span>

                            <span class="dash-details-card-item-title">
                                {{renderActualDateTime()}}
                            </span>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>


                        <div class="col-4">
                            <p class="label">Nome</p>
                            <p class="value">
                                {{form.controls.type_document.value}}</p>
                        </div>

                        <div class="col-4">
                            <p class="label">Sistema</p>
                            <p class="value">{{renderSystem()}}</p>
                        </div>

                        <div class="col-4">
                            <p class="label">Evento</p>
                            <p class="value">{{renderEvent()}}</p>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-4">
                            <p class="label">Descrição</p>
                            <p class="value">{{form.controls.description.value}}
                            </p>
                        </div>
                    </div>

                    <app-spacer [top]="48"></app-spacer>

                    <div class="row">
                        <div
                            class="col-12 d-flex justify-content-between align-items-center">

                            <app-button
                                (onClick)="redirect()"
                                class="add-button" [phantom]="true">
                                Cancelar
                            </app-button>

                            <div class="d-flex align-items-center">
                                <app-button (onClick)="showForm = true"
                                    *ngIf="!showForm" class="add-button"
                                    [outline]="true">
                                    Voltar
                                </app-button>

                                <app-spacer [right]="16"></app-spacer>

                                <app-button (onClick)="handleSubmit()"
                                    [loading]="sending" class="add-button"
                                    [disabled]="getDisabled()">
                                    {{renderButtonText()}}
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>